/// <reference path="../../../Modules/Products/Products/ProductsGrid.ts" />

namespace RioERP.Enquiry {

    export interface ProductPickerOptions {
        hideProducts?: string[];
    }
    import fld = Products.ProductsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class EnquiryProductsCheckGrid extends Serenity.EntityGrid<Products.ProductsRow, ProductPickerOptions> {
       
        private ProductId;
        private EnquiryId;
        protected getColumnsKey() { return "Products.Products"; }
        protected getDialogType() { return <any>Products.ProductsDialog; }
        protected getIdProperty() { return Products.ProductsRow.idProperty; }
        protected getLocalTextPrefix() { return Products.ProductsRow.localTextPrefix; }
        protected getService() { return Products.ProductsService.baseUrl; }
      
        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery, options: ProductPickerOptions) {
            super(container, options);
           
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            //buttons[0].onClick:()
            return buttons;
        }

        get selectedItems() {
           
            return this.rowSelection.getSelectedAsInt32().map(x => this.view.getItemById(x));
        }

        get ProductsId() {
            return this.ProductId;
        }

        get EnquirysId() {
            
            return this.EnquiryId;
        }
        

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            if (this.options.hideProducts && this.options.hideProducts.length)
                request.Criteria = Serenity.Criteria.and(request.Criteria,
                    [[Products.ProductsRow.Fields.Id], 'not in', [this.options.hideProducts]]);

            return true;
        }
    }
}